import React from 'react';

import { Box, Typography } from '@mui/material';

import type { CompetitorProperty } from '~/types/services/priceParrot';

import CompetitorOfferLeFlashChip from './CompetitorOfferLeFlashChip';
import { plural } from './utils';

interface Props {
  property: CompetitorProperty;
}

export default function CompetitorOfferLeFlashCell({ property }: Props) {
  return (
    <Box>
      <CompetitorOfferLeFlashChip status={property.leFlashStatus} />
      {property.leOffers.length > 0 && (
        <Typography variant="caption" color="text.secondary" component="div" mt={0.5}>
          {plural(property.leOffers.length, 'Flash offer')}
        </Typography>
      )}
    </Box>
  );
}
